<p class="main-value">
  {{ formattedValue() }}
</p>
@if (formattedGrowthValue(); as growthValue) {
  <p class="growth-value">
    {{ growthValue }}
  </p>
}
